module.exports = __webpack_public_path__ + "media/configurations/X-X-P-5f999627.png";